/* eslint-disable */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { autobind } from 'core-decorators';
import classNames from 'classnames';
import browserHistory from 'react-router/lib/browserHistory';
import { get, size, debounce} from 'lodash';
import CSSModules from 'react-css-modules';
import Lightbox from 'react-images';

import { COMMUNITIES, POST, PUBLIC_PROFILE } from '../../constants/routes';
import { COMMUNITY_POST_MENU } from '../../constants/strings';

import Avatar from '../Avatar';
import Header from './Header';
import Body from './Body';
import Footer from './Footer';
import Image from './Image';
import Video from './Video';
import UrlPreview from '../Community/NewPost/UrlPreview';
import IconMenu from '../common/IconMenu';

import ActionConfirmation from '../common/ActionConfirmation';
import EditPost from '../Community/NewPost/EditPost';

import { ALLOW_SOCIAL_CHAT_CREATION } from '../../constants/chat';
import { actions as likePostActions } from '../../redux/communities/likePost';
import { actions as dislikePostActions } from '../../redux/communities/dislikePost';
import { actions as reqSocialChannel } from '../../redux/board/reqSocialChannel';
import { actions as joinPopupActions } from '../../redux/communities/joinPopup';
import { actions as postsListActions } from '../../redux/communities/postsList';
import { loggedUserIdSelector } from '../../redux/context/selectors';
import { isLoggedInSelector } from '../../redux/auth/selectors';
import { currentCommunityInfoSelector } from '../../redux/communities/selectors/currentCommunity';
import { COMMUNITIES_ACCESS_LEVELS } from '../../constants';
import withPopoverMenu from '../../hocs/withPopoverMenu'
import { reportActions } from '../../redux/ui/popup';
import { IDS } from '../../constants/ids';
import Icon from '../Icon';
import { COLORS } from '../../constants/styles';

import styles from './index.styl';

const {
  READ_AND_POST_WITH_APPROVAL,
  READ_AND_POST,
  READ_ONLY,
} = COMMUNITIES_ACCESS_LEVELS;

const createRoute = (communityId, postId) =>
  communityId && postId
    ? `/${COMMUNITIES}/${communityId}/${POST}/${postId}`
    : '';

const mapStateToProps = state => ({
  likeRequestPending:
    state.communities.likePost.sending || state.communities.dislikePost.sending,
  loggedUserId: loggedUserIdSelector(state),
  currentCommunityInfo: currentCommunityInfoSelector(state),
  isLoggedIn: isLoggedInSelector(state),
});

const mapDispatchToProps = {
  likePost: likePostActions.send,
  dislikePost: dislikePostActions.send,
  createSocialChat: reqSocialChannel.send,
  openJoinPopup: joinPopupActions.show,
  removePostNewStatus: postsListActions.removeNewPostStatus,
  showPostReport: reportActions.post
};

@withPopoverMenu
@injectIntl
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@CSSModules(styles, { allowMultiple: true })
export default class PostPreview extends PureComponent {
  static propTypes = {
    id: PropTypes.number,
    content: PropTypes.string,
    author: PropTypes.shape({
      id: PropTypes.number,
      user: PropTypes.shape({
        id: PropTypes.number,
        avatar: PropTypes.objectOf(PropTypes.string),
        aliasName: PropTypes.string,
      }),
      role: PropTypes.string,
    }),
    totalComments: PropTypes.number,
    totalLikes: PropTypes.number,
    attachment: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string,
      }),
      urlPreview: PropTypes.object,
    }),
    publishedAt: PropTypes.string,
    organization: PropTypes.string,
    communityId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    isLink: PropTypes.bool,
    onDelete: PropTypes.func,
    onEdit: PropTypes.func,
    intl: PropTypes.object,
    updated: PropTypes.bool,
    likePost: PropTypes.func,
    dislikePost: PropTypes.func,
    liked: PropTypes.bool,
    likeRequestPending: PropTypes.bool,
    loggedUserId: PropTypes.number,
    createSocialChat: PropTypes.func,
    isModerator: PropTypes.bool,
    currentUserRole: PropTypes.string,
    currentCommunityInfo: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    openJoinPopup: PropTypes.func,
    getMenuItems: PropTypes.func.isRequired,
    showPostReport: PropTypes.func,
    pinned: PropTypes.bool,
  };

  state = {
    onDeleteRequested: false,
    lightboxIsOpen: false,
    currentImageIndex: 0,
    isForceOpenDeletePopup: false,
  };

  componentDidMount(prevProps) {
    const { isNewPost } = this.props;
    if (isNewPost) {
      this.debouncedOnDispatch();
    }
  }

  debouncedOnDispatch = debounce(() => {
    const { removePostNewStatus, id } = this.props;
    removePostNewStatus(id);
  }, 10000);

  @autobind
  toggleRequestDelete(flag) {
    this.setState({
      onDeleteRequested: flag,
      isForceOpenDeletePopup: flag,
    });
  }

  @autobind
  onRequestEdit() {
    this.editPost.forceOpen();
    this.setState({
      onEditRequested: true,
    });
  }

  editPost = null;

  @autobind
  handleLike() {
    const { id, liked, likePost, dislikePost, likeRequestPending } = this.props;
    const action = liked ? dislikePost : likePost;

    if (!likeRequestPending) {
      action({ postId: id });
    }
  }

  @autobind
  onRequestSendMessage() {
    const { createSocialChat } = this.props;
    createSocialChat({ participants: [this.authorId] });
  };

  @autobind
  onRequestReport() {
    const { showPostReport, id } = this.props;
    showPostReport(id);
  }

  get authorId() {
    const { author } = this.props;
    return get(author, 'user.id');
  }

  handleOpenLightbox = index => {
    this.setState({
      lightboxIsOpen: true,
      currentImageIndex: index,
    });
  };

  handleCloseLightbox = () => {
    this.setState(prevState => ({
      lightboxIsOpen: !prevState.lightboxIsOpen,
    }));
  };

  gotoPreviousImage = galleryImages => {
    const { currentImageIndex } = this.state;
    this.setState({
      currentImageIndex:
        (currentImageIndex + size(galleryImages) - 1) % size(galleryImages),
    });
  };

  gotoNextImage = galleryImages => {
    const { currentImageIndex } = this.state;
    this.setState({
      currentImageIndex: (currentImageIndex + 1) % size(galleryImages),
    });
  };

  gotoProfile = () => browserHistory.push(`${PUBLIC_PROFILE}/${this.authorId}`);

  render() {
    const {
      id,
      content,
      author,
      totalComments,
      totalLikes,
      attachment,
      publishedAt,
      organization,
      communityId,
      isLink,
      onDelete,
      onEdit,
      intl,
      updated,
      liked,
      intl: { formatMessage },
      loggedUserId,
      isModerator,
      currentUserRole,
      currentCommunityInfo,
      openJoinPopup,
      isLoggedIn,
      isNewPost,
      getMenuItems,
      pinned,
    } = this.props;

    const { onDeleteRequested, currentImageIndex, lightboxIsOpen, isForceOpenDeletePopup } = this.state;
    const route = createRoute(communityId, id);
    const redirect = () => browserHistory.push(route);
    const images = get(attachment, 'files');
    const link = get(attachment, 'urlPreview');
    const accessLevel = get(currentCommunityInfo, 'accessLevel');

    const isLoggedUserComment = loggedUserId === this.authorId;

    const getMenuOptions = () => {
      let options = {
        removePost: !!currentUserRole && onDelete && this.toggleRequestDelete.bind(this, true),
        editPost: !!currentUserRole && accessLevel !== READ_AND_POST_WITH_APPROVAL && onEdit && this.onRequestEdit,
        report: !isLoggedUserComment && this.onRequestReport
      };

      if (ALLOW_SOCIAL_CHAT_CREATION) {
        const sendMessageMenuItem = { sendMessage: !!currentUserRole && !isLoggedUserComment && this.onRequestSendMessage };

        options = { ...options, ...sendMessageMenuItem };
      }

      return options;
    }

    const menu = getMenuItems(getMenuOptions());

    const galleryImages = images && images.map(image => ({ src: image.url }));

    const previewImages = images && images.slice(0, 4);
    const fullWidthImg = size(previewImages) !== 2;
    const counter = size(images) - size(previewImages);
    const canComment =
     isModerator || accessLevel !== READ_ONLY;

    return (
      <div styleName={classNames('root', { danger: onDeleteRequested })}>
        <If condition={!isLoggedIn}>
          <div
            styleName="overlay"
            onClick={() => openJoinPopup({ content: 'join' })}
          />
        </If>
        <If condition={menu.length}>
          <IconMenu
            id={IDS.POST.MENU_TRIGGER}
            position={{ horizontal: 'right', vertical: 'bottom' }}
            items={menu}
            style={{
              position: 'absolute',
              top: '8px',
              right: '16px',
            }}
            allScreens
          />
        </If>
        {pinned && (
          <div styleName="header__pinnedStatus">
            <Icon name="pin" size={16} style={{fill: COLORS.blueAccentPlus}}/>
            <div styleName="status">
              {formatMessage({ id: 'community.pinnedPost' })}
            </div>
          </div>
        )}
        <div styleName="grid">
          <div styleName="image" className="pointer" onClick={this.gotoProfile}>
            <Avatar
              children={get(author, 'user.aliasName')}
              size={40}
              src={get(author, 'user.avatar.thumbMin')}
            />
          </div>
          <div styleName="content">
            <Header
              {...{ author, organization, publishedAt, updated, isNewPost }}
              onTitleClick={this.gotoProfile}
            />
          </div>
        </div>
        <Body
          {...{ content }}
          redirect={isLink && redirect}
          disabled={!currentUserRole}
        />
        <If condition={size(images)}>
          <div styleName="image-grid square portrait">
            {previewImages.map((image, index) => (
              <Image
                className={classNames('grid-item', {
                  'grid-item--first': fullWidthImg,
                  'grid-item--counter': !!counter,
                })}
                image={image}
                counter={index === 3 && counter !== 0 ? counter : null}
                onOpen={() => this.handleOpenLightbox(index)}
                key={image.index}
              />
            ))}
          </div>
        </If>
        <Lightbox
          images={galleryImages || []}
          isOpen={lightboxIsOpen}
          onClickPrev={() => this.gotoPreviousImage(galleryImages)}
          onClickNext={() => this.gotoNextImage(galleryImages)}
          onClose={this.handleCloseLightbox}
          currentImage={currentImageIndex}
          backdropClosesModal
          showImageCount={false}
        />
        <If condition={get(link, 'url')}>
          <Choose>
            <When condition={link.video && link.video !== 'null'}>
              <div styleName="videoPreviewContainer">
                <Video src={link.video} />
              </div>
            </When>
            <Otherwise>
              <a
                href={link.url}
                target="blank"
                styleName="urlPreviewContainer"
                className="flex mt3 mb3"
              >
                <UrlPreview {...link} readonly />
              </a>
            </Otherwise>
          </Choose>
        </If>
        <Footer
          {...{ totalComments, totalLikes, liked }}
          redirect={isLink && redirect}
          likeAction={this.handleLike}
          canComment={canComment}
          currentUserRole={currentUserRole}
          isLoggedIn={isLoggedIn}
        />
        <ActionConfirmation
          intl={intl}
          onClose={this.toggleRequestDelete.bind(this, false)}
          onSubmit={onDelete}
          opened={isForceOpenDeletePopup}
          title={formatMessage(COMMUNITY_POST_MENU.deletePost)}
          body={formatMessage(COMMUNITY_POST_MENU.confirmDeleteMessage)}
          actionButtonText={formatMessage(COMMUNITY_POST_MENU.deletePost)}
        />
        <EditPost
          intl={intl}
          onCancel={() => this.setState({ onEditRequested: false })}
          editPost={onEdit}
          ref={node => (this.editPost = node)}
          communityId={communityId}
          postId={id}
          content={content}
          attachment={attachment}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PostPreview/index.jsx